/** Money in VND, written the way Vietnamese listings actually write it. */
export function money(value: number): string {
  if (!Number.isFinite(value)) return '—';
  if (Math.abs(value) >= 1_000_000_000) {
    return `${trim(value / 1_000_000_000)} tỷ`;
  }
  if (Math.abs(value) >= 1_000_000) {
    return `${trim(value / 1_000_000)} triệu`;
  }
  return new Intl.NumberFormat('vi-VN').format(value);
}

export function fullMoney(value: number): string {
  return `${new Intl.NumberFormat('vi-VN').format(Math.round(value))} ₫`;
}

function trim(value: number): string {
  return value
    .toFixed(value < 10 ? 2 : 1)
    .replace(/\.?0+$/, '')
    .replace('.', ',');
}

export function number(value: number, digits = 0): string {
  return new Intl.NumberFormat('vi-VN', {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(value);
}

/** `2026-08-15` → `15/08/2026`. Accepts a date-time string too. */
export function date(iso: string): string {
  const value = new Date(iso);
  if (Number.isNaN(value.getTime())) return iso;
  return value.toLocaleDateString('vi-VN', {day: '2-digit', month: '2-digit', year: 'numeric'});
}

export function time(iso: string): string {
  const value = new Date(iso);
  if (Number.isNaN(value.getTime())) return '';
  return value.toLocaleTimeString('vi-VN', {hour: '2-digit', minute: '2-digit'});
}

export function dayLabel(iso: string): string {
  const value = new Date(iso);
  if (Number.isNaN(value.getTime())) return iso;
  const today = startOfDay(new Date());
  const diff = Math.round((startOfDay(value).getTime() - today.getTime()) / 86_400_000);
  if (diff === 0) return 'Hôm nay';
  if (diff === 1) return 'Ngày mai';
  if (diff === -1) return 'Hôm qua';
  return value.toLocaleDateString('vi-VN', {weekday: 'short', day: '2-digit', month: '2-digit'});
}

export function startOfDay(value: Date): Date {
  const copy = new Date(value);
  copy.setHours(0, 0, 0, 0);
  return copy;
}

export function todayISO(): string {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60_000;
  return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}

/** `2026-08-15T09:30` for `<input type="datetime-local">`. */
export function toLocalInput(iso: string): string {
  const value = new Date(iso);
  if (Number.isNaN(value.getTime())) return '';
  const offset = value.getTimezoneOffset() * 60_000;
  return new Date(value.getTime() - offset).toISOString().slice(0, 16);
}

export function daysBetween(fromISO: string, toISO: string): number {
  const from = startOfDay(new Date(fromISO)).getTime();
  const to = startOfDay(new Date(toISO)).getTime();
  return Math.round((to - from) / 86_400_000);
}
